import React from 'react';

const SelectField = ({ label, name, defaultValue, value, options, onChange, valueField, textField, register, explanation, rules, error, placeholder }) => (
    <div className='mb-3 flex items-center w-full'>
        <label className='w-1/6 text-uidarker font-medium pr-6 text-right'>{label}:</label>
        <select
            {...register(name, rules)}
            defaultValue={defaultValue}
            className='bg-uilight border-solid border-2 border-uidark rounded-full py-1 px-4 w-full max-w-xs'
            onChange={onChange}
        >
            {placeholder && <option value="">{placeholder}</option>}
            {options.map((option, index) => {
                const v = valueField ? option[valueField] : option;
                const t = textField ? option[textField] : option;
                return (
                    <option key={index} value={v}>{t}</option>
                )
            })}
        </select>
        {explanation && (
            <span className='text-brandDarkBlue text-xs text-gray-500 my-1'>{explanation}</span>
        )}
        {error && <span className='text-red text-xs'>{error}</span>}
    </div>
);

export default SelectField;
